import PropTypes from 'prop-types'
import { isEmpty } from 'lodash'

import Toggle from 'react-toggle'

const ToggleButton = ({ field, ...props }) => {
  const { disabled } = props

  let name, onChange, value
  if (!isEmpty(field)) {
    name = field.name
    onChange = field.onChange
    value = field.value
  } else {
    name = props.name
    onChange = props.onChange
    value = props.value
  }

  return (
    <Toggle
      checked={value}
      icons={false}
      name={name}
      onChange={onChange}
      disabled={disabled}
    />
  )
}

ToggleButton.propTypes = {
  field: PropTypes.shape({
    name: PropTypes.string.isRequired,
    onChange: PropTypes.func.isRequired,
    value: PropTypes.bool.isRequired,
  }).isRequired,
}

export default ToggleButton
